<template>
  <div class="bg-[#2C7952]/20 px-[10px] py-2 mb-[1px] rounded-b-2xl">
    <div
      class="flex items-center justify-between bg-[#2C7952]/40 h-[44px] px-2 rounded-lg"
    >
      <div class="flex items-center">
        <span class="text-white text-[13px]"> {{ $t('Activities.Agentcenter.Components.GanhosContent.EstimatedRevenue') }} </span>
        <Image :src="question" alt="" class="w-[15px] h-[15px] ml-1" />
      </div>
      <div class="flex items-center">
        <span class="text-[#FFDF12] text-[15px] font-[500]">
          {{ formatter().format(agentUnsettledAmount || 0) }}
        </span>
      </div>
    </div>
    <div class="flex mt-2">
      <div class="centerBox">
        <span> {{ $t('Activities.Agentcenter.Components.GanhosContent.TeamDeposit') }} </span>
        <span>
          {{ formatter().format(agentInfoMeusGanhos.teamTotalDeposit || 0) }}
        </span>
      </div>
      <div class="centerBox">
        <span> {{ $t('Activities.Agentcenter.Components.GanhosContent.DepositCommission') }} </span>
        <span class="text-[#FFDF12] font-[500]">
          {{ formatter().format(agentInfoMeusGanhos.teamDepositAgentAmount || 0) }}
        </span>
      </div>
      <div class="centerBox">
        <span> {{ $t('Activities.Agentcenter.Components.GanhosContent.TeamBet') }} </span>
        <span> {{ formatter().format(agentInfoMeusGanhos.teamTotalBet || 0) }} </span>
      </div>
      <div class="centerBox">
        <span> {{ $t('Activities.Agentcenter.Components.GanhosContent.BetCommission') }} </span>
        <span class="text-[#FFDF12] font-[500]">
          {{ formatter().format(agentInfoMeusGanhos.teamBetAgentAmount || 0) }}
        </span>
      </div>
    </div>
  </div>
  <div class="bg-[#2C7952]/20 px-[10px] py-2 rounded-b-2xl">
    <div class="flex items-center justify-between">
      <div class="flex items-start">
        <span class="text-white text-[13px]"> {{ $t('Activities.Agentcenter.Components.GanhosContent.AvailableCommission') }} </span>
      </div>
    </div>
    <div class="flex items-center justify-between mt-2">
      <div
        class="text-white w-full flex items-center py-2 px-5 rounded-lg break-all border border-solid border-[#B0B7BB]"
      >
        <span>{{ $t('Activities.Agentcenter.Components.GanhosContent.Value') }}</span>
        <div class="h-4 w-[1px] bg-[#ffffff]/50 mx-3"></div>
        <span class="text-[#FFDF12] text-[15px] font-[600]">
          {{ formatter().format(agentInfoMeusGanhos.availableAgentAmount || 0) }}
        </span>
      </div>
      <van-button
        :class="[
          '!w-[100px] !h-[34px] !text-[13px] !ml-2',
          Number(agentInfoMeusGanhos.availableAgentAmount) === 0
            ? 'primaryBtn_transparent'
            : 'primaryBtn',
        ]"
        :disabled="Number(agentInfoMeusGanhos.availableAgentAmount) === 0"
        @click="getAgentProfits()"
      >
        {{ $t('Activities.Agentcenter.Components.GanhosContent.Receive') }}
      </van-button>
    </div>
    <div class="text-base text-white mt-2">
      <span class="text-white/75 mr-1 text-[13px]"> {{ $t('Activities.Agentcenter.Components.GanhosContent.ReceivedEarnings') }} </span>
      <span>{{ formatter().format(agentInfoMeusGanhos.receivedAgentAmount || 0) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { receber } from "@/hooks/useActivity";
import { formatter } from "@/utils";
import question from "./../images/question.png";
import { getAgentUnsettledAmount } from "@/api/agent";
import { useRoute } from "vue-router";
const activityId: any = useRoute().query.activityId || "";

const emit = defineEmits(["update"]);
const { agentInfoMeusGanhos } = defineProps<{
  agentInfoMeusGanhos: any;
}>();

const agentUnsettledAmount = ref<any>(0);
// 获取待结算收益金额
const getAgentUnsettledAmountData = async () => {
  let { code, data } = await getAgentUnsettledAmount();
  if (code === 1) {
    agentUnsettledAmount.value = data;
  }
};

// 领取代理奖励
const getAgentProfits = async () => {
  await receber({
    flowType: "AgentCommission",
    activityId,
  });
  emit("update");
};

onMounted(() => {
  getAgentUnsettledAmountData();
});
</script>

<style scoped lang="scss">
.centerBox {
  @apply flex-1 ml-[2px] flex-center flex-col h-[64px] text-white/50 bg-[#2C7952]/20 rounded-lg text-[11px];
  span:nth-child(1) {
    @apply text-center;
  }
  span:nth-child(2) {
    @apply mt-1;
  }
}
</style>
